module.exports = __webpack_public_path__ + "img/maria-full.a7abb4e5.png";